(function($, angular, window) {
    'use strict';
    window.THF.Angular.Filters.filter("renderHTML", ['$sce', function($sce) {
        return function(htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        }
    }]);

})(jQuery, angular, window);
